import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import JobStatus from '../components/JobStatus';
import ResultsViewer from '../components/ResultsViewer';
import { checkCsvAvailability, getJobResults } from '../services/api';

const ResultsPage = () => {
  const { jobId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [isComplete, setIsComplete] = useState(false);
  const [csvAvailable, setCsvAvailable] = useState(false);
  const configChoice = location.state?.configChoice || 'Unknown';
  
  // const API_BASE_URL = 'http://localhost:8000';
  // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  // const API_BASE_URL = 'https://ews-gcs-api-258557095482.us-central1.run.app';
  // const API_BASE_URL = 'https://ews-gcs-api4-258557095482.us-central1.run.app';
  // const API_BASE_URL = 'https://ews-gcs-api5-258557095482.us-central1.run.app'; 
  // const API_BASE_URL = 'https://ews-gcs-api6-258557095482.us-central1.run.app'

  //const API_BASE_URL = 'https://ews-gcs-api9-258557095482.us-central1.run.app';
  const API_BASE_URL = 'https://ews-gcs-api10-258557095482.us-central1.run.app'



  useEffect(() => {
    // Check if CSV is available when the job is complete
    if (isComplete) {
      const checkForCsv = async () => {
        try {
          const result = await getJobResults(jobId);
          setCsvAvailable(result.has_csv_export || false);
        } catch (error) {
          console.error('Error checking CSV availability:', error);
          // Default to showing download button anyway
          setCsvAvailable(false);
        }
      };
      
      checkForCsv();
    }
  }, [isComplete, jobId]);

  const handleJobComplete = () => {
    setIsComplete(true);
  };

  const handleBackToUpload = () => {
    navigate('/');
  };

  const handleDownloadCsv = () => {
    // Create download link for CSV
    const csvUrl = `${API_BASE_URL}/csv/${jobId}`;
    
    // Create a temporary anchor element to trigger download
    const a = document.createElement('a');
    a.href = csvUrl;
    a.download = `ews_summary_${jobId}.csv`;
    a.target = '_blank'; // Open in new tab if download doesn't start automatically
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="results-page">
      <div className="page-header">
        <h1>Analysis Results</h1>
        <div className="job-info">
          <span>Job ID: {jobId}</span>
          <span>Configuration: {configChoice}</span>
          
          {isComplete && csvAvailable && (
            <span className="csv-download">
              <button 
                onClick={handleDownloadCsv}
                className="download-csv-button"
              >
                Download CSV Summary
              </button>
            </span>
          )}
        </div>
      </div>
      
      {!isComplete && (
        <JobStatus
          jobId={jobId}
          onJobComplete={handleJobComplete}
        />
      )}
      
      {isComplete && (
        <ResultsViewer jobId={jobId} />
      )}
      
      <div className="page-actions" style={{ marginTop: '20px' }}>
        <button onClick={handleBackToUpload} className="back-button">
          ← Back to Upload
        </button>
        
        {isComplete && csvAvailable && (
          <button 
            onClick={handleDownloadCsv}
            className="download-csv-button"
          >
            Download EWS Data as CSV
          </button>
        )}
      </div>
    </div>
  );
};

export default ResultsPage;